













import { AuthService } from "@/services/auth/auth.service";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "wonder-point-component",
})
export default class WonderPointComponent extends Vue {
  async mounted() {
    const authService = new AuthService();
    await authService.refreshToken(true);
  }
  get active(): boolean {
    return this.$store.getters["SystemStore/getOpenWonderPointModal"];
  }
  set active(e) {
    if (!e) {
      const aux = this.$store.getters["SystemStore/getWonderPointUrl"];
      if (aux.includes(process.env.VUE_APP_TOOLKIT_URL && process.env.VUE_APP_ENVIRONMENT === "PRO")) {
        const space = this.$store.getters["SpaceStore/getSpace"];
        const user = this.$store.getters["UserStore/getSpaceUser"];
        //LOAD POWER_UP NOTIFICATIONS
        this.$store.dispatch("SidebarStore/getPowerUpsNotificationsAction", {
          userId: user.superSpaceUser.user.id,
          spaceId: space.id,
        });
        /////////////////////////////
      }
      this.$store.dispatch("SystemStore/setWonderPointUrlAction", "");
    }
    this.$store.dispatch("SystemStore/setOpenWonderPointModalAction", e);
  }
  get getUrl() {
    const aux = this.$store.getters["SystemStore/getWonderPointUrl"];
    return aux.includes(process.env.VUE_APP_TOOLKIT_URL)
      ? `${aux}?${this.serialize()}`
      : aux;
  }
  serialize(): string {
    return `${encodeURIComponent("companyID")}=${encodeURIComponent(
      this.$store.getters["SpaceStore/getSpace"].id
    )}`;
  }
}
